/* eslint-disable @typescript-eslint/no-magic-numbers */
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row, Tooltip } from 'antd';
import { Block } from 'components/block';
import { CertificateEmptyIcon, InfoCircleIcon } from 'components/icons';
import { EpCertificate } from 'types/graphql-types';
import { Certificate } from './certificate';
import styles from './styles.less';

type CertificatesViewProps = {
  certificates: EpCertificate[];
};

export const CertificatesView: FC<CertificatesViewProps> = ({
  certificates,
}) => {
  const { t } = useTranslation('translation');

  const infoCircle = (
    <Tooltip title="This section shows the certificates that the employee has from EMS.">
      <InfoCircleIcon />
    </Tooltip>
  );

  return (
    <Block title={t('Certificates')} subTitle={infoCircle}>
      {certificates.length === 0 ? (
        <CertificateEmptyIcon className={styles['certificate-empty-icon']} />
      ) : (
        <Row gutter={[16, 16]}>
          {certificates.map((certificate) => (
            <Col
              span={24}
              sm={{ span: 12 }}
              lg={{ span: 8 }}
              key={certificate.certificate}
            >
              <Certificate {...certificate} />
            </Col>
          ))}
        </Row>
      )}
    </Block>
  );
};
